//@flow
import React from 'react';

type State = {
  mainTitle: string,
  subTitle: string
};

type Payload = {
  mainTitle: string,
  subTitle: string,
  canBack: boolean,
  backUrl: string,
  backConfirmObject: Object
};

export default {
  state: { mainTitle: 'SASC CM', subTitle: '', canBack: false, backConfirmObject: null, onClickBack: null },
  reducers: {
    changePageTitle: (state: State, payload: Payload) => {
      return Object.assign({}, state, {
        mainTitle: payload.mainTitle ? payload.mainTitle : state.mainTitle,
        subTitle: payload.subTitle,
        canBack: payload.canBack,
        backUrl: payload.backUrl,
        backConfirmObject: payload.backConfirmObject,
        onClickBack: payload.onClickBack,
      });
    }
  }
};
